var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticClass:"statistics-extra-chart"})
}
var staticRenderFns = []

export { render, staticRenderFns }